import './style.scss';
import Swiper from 'swiper';
import 'swiper/swiper.scss';
export function team_block() {
    const block = document.querySelector('.team_block');
    if (!block) return;
    let teamsSwiper = null;

    function initBenefitsSwiper() {
        const container = document.querySelector('.teams-swiper');

        if (window.innerWidth < 1024) {
            if (!teamsSwiper) {
                teamsSwiper = new Swiper(container, {
                    slidesPerView: "1.27",
                    observer: true,          // ✅ يتابع أي تغيير في DOM
                    observeParents: true,
                    breakpoints: {
                        768: {
                            slidesPerView: '2',
                        },
                        992: {
                            slidesPerView: '3',
                        }
                    }
                });
            }
        } else {
            if (teamsSwiper) {
                teamsSwiper.destroy(true, true);
                teamsSwiper = null;
            }
        }
    }

// Run on load
    initBenefitsSwiper();

// Run on resize
    window.addEventListener('resize', () => {
        initBenefitsSwiper();
    });
}
